import { useAuthContext } from '../hooks';
import Page403 from 'src/pages/error_pages/Page403';

// ----------------------------------------------------------------------

type RoleBasedGuardProp = {
  hasContent?: boolean;
  roles?: string[];
  children: React.ReactNode;
};

export default function RoleBasedGuard({ hasContent, roles, children }: RoleBasedGuardProp) {
  // Logic here to get current user role 
  const { user } = useAuthContext();

  // const currentRole = 'user';
  const currentRole = user?.role?.name; // admin;

  if (typeof roles !== 'undefined' && !roles.includes(currentRole)) {
    return hasContent ? <Page403 /> : null;
  }

  return <> {children} </>;
}
